import type { UserRole } from '@shared/types';

export interface NavItem {
  label: string;
  path: string;
  icon: string;
  children?: NavItem[];
  // 必要な最低ロール（階層判定。上位ロールも表示対象）。
  requiredRole?: UserRole;
}

export const NAV_ITEMS: NavItem[] = [
  { label: 'ダッシュボード', path: '/', icon: 'home' },
  { label: '受注管理', path: '/orders', icon: 'shopping-cart' },
  { label: '見積管理', path: '/quotes', icon: 'file-text' },
  { label: '注文管理', path: '/purchase-orders', icon: 'clipboard-list' },
  { label: '納品書管理', path: '/deliveries', icon: 'truck' },
  { label: '請求管理', path: '/invoices', icon: 'credit-card' },
  { label: '支払管理', path: '/payable', icon: 'wallet' },
  { label: '月次締め処理', path: '/closings', icon: 'lock', requiredRole: 'accounting' },
  { label: '入金管理', path: '/payments', icon: 'bank' },
  { label: '顧客管理', path: '/customers', icon: 'users' },
  { label: '商品管理', path: '/products', icon: 'box' },
  { label: '帳票管理', path: '/documents', icon: 'printer' },
  { label: 'レポート', path: '/reports', icon: 'bar-chart' },
  {
    label: 'マスタ管理',
    path: '/master',
    icon: 'database',
    children: [
      { label: '自社情報', path: '/master/company-profile', icon: 'building', requiredRole: 'admin' },
      { label: '締め日', path: '/master/limit-types', icon: 'calendar', requiredRole: 'admin' },
      { label: '支払日', path: '/master/payment-dates', icon: 'credit-card', requiredRole: 'admin' },
      { label: '単位', path: '/master/units', icon: 'list', requiredRole: 'admin' },
      { label: '銀行口座', path: '/master/banks', icon: 'bank', requiredRole: 'admin' },
      { label: '業種', path: '/master/business-types', icon: 'briefcase', requiredRole: 'admin' },
      { label: '取引形態', path: '/master/trade-types', icon: 'shuffle', requiredRole: 'admin' },
      { label: '社員分類', path: '/master/employee-categories', icon: 'tag', requiredRole: 'admin' },
      { label: '社員', path: '/master/employees', icon: 'user', requiredRole: 'admin' },
      { label: '部署', path: '/master/usergroups', icon: 'building', requiredRole: 'admin' },
    ],
  },
  {
    label: '設定',
    path: '/settings',
    icon: 'settings',
    children: [
      { label: 'ユーザー管理', path: '/settings/users', icon: 'user-cog', requiredRole: 'admin' },
      { label: '組織管理', path: '/settings/organization', icon: 'building', requiredRole: 'admin' },
      { label: '外部連携', path: '/settings/integrations', icon: 'link', requiredRole: 'admin' },
    ],
  },
];
